import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {PartnerAdvertisingPlatform} from '../../../../../models/partner/partner-advertising-platform';
import {PartnerMicrosoftAdsService} from '../../../../../services/partner/partner-microsoft-ads.service';
import {IsGrantedDirective} from '../../../../../directives/is-granted/is-granted.directive';

@Component({
  imports: [
    IsGrantedDirective
  ],
  selector: 'app-microsoft-ads-config-form',
  styleUrl: './microsoft-ads-config-form.component.scss',
  templateUrl: './microsoft-ads-config-form.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MicrosoftAdsConfigFormComponent implements OnChanges {
  @Input() partnerAdvertisingPlatform: PartnerAdvertisingPlatform | null = null;

  conversionGoals: any[] | null = null;
  partnerId: number | null = null;

  constructor(
    private partnerMicrosoftAdsService: PartnerMicrosoftAdsService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['partnerAdvertisingPlatform']) {
      this.partnerId = this.partnerAdvertisingPlatform?.partnerId ?? null;
      this.refreshActionStatus();
    }
  }

  linkToMicrosoftAdvertising(): void {
    if (this.partnerId) {
      this.partnerMicrosoftAdsService.getAuthenticationLink(this.partnerId).subscribe(response => {
        window.location.href = response.link;
      });
    }
  }

  refreshActionStatus(): void {
    const authInfo = this.partnerAdvertisingPlatform?.authenticationInfo;

    if (this.partnerId && authInfo && authInfo?.accessToken) {
      this.conversionGoals = null;
      this.partnerMicrosoftAdsService.getConversionGoalsStatus(this.partnerId).subscribe((goals) => {
        this.conversionGoals = goals;
      });
    }
  }
}
